export default "__VITE_ASSET__dg5SkKZ9__"